export enum PractitionerRole {
    organizationPayoutManager = 'organizationPayoutManager',
}
